<template>
  <div class="island">
    <b-container>
      <b-row class="justify-content-md-center">
        <b-col>
    <b-list-group class="grade-select">
        <b-list-group-item active class="heading">
          <h4 class="list-group-item-heading text-center">Choose your grade level...</h4>
        </b-list-group-item>

        <b-list-group-item to="/Students/prek" class="semitransparent">
          <h4 class="text-center">Preschool-Kindergarten</h4>
          <p class="hidden">Letters, Numbers, Shapes, Etc.</p>
        </b-list-group-item>

        <b-list-group-item to="/Students/1to3" class="semitransparent">
          <h4 class="list-group-item-heading text-center">1st - 3rd Grade</h4>
          <p class="list-group-item-text hidden">Math facts, animals, weird stuff, etc.</p>
        </b-list-group-item>

        <b-list-group-item to="/Students/4to6" class="semitransparent">
          <h4 class="list-group-item-heading text-center">4th - 6th Grade</h4>
          <p class="list-group-item-text hidden">Math facts, animals, weird stuff, etc.</p>
        </b-list-group-item>

        <b-list-group-item to="/Students/7up" class="semitransparent">
          <h4 class="list-group-item-heading text-center">7th Grade and Up</h4>
          <p class="list-group-item-text hidden">Math facts, animals, weird stuff, etc.</p>
        </b-list-group-item>
      
        <b-list-group-item active class="footer">
          
        </b-list-group-item>
    </b-list-group>
  </b-col>
  </b-row>
</b-container>
  </div>
</template>

<script>
export default {
  name: 'Students',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.island {
  background-image:url("../assets/img/world/island_test.jpg");
  background-position: 0 -90px;
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  height:1110px;
  border:none;
}

.semitransparent {
  background-color: rgba(255,255,255,0.7);
}

.semitransparent:hover {
  background-color: #FFCC00!important;
}

.grade-select {
  margin-top: 100px;
}

.grade-select .heading {
  border-top-left-radius: 20px!important;
  border-top-right-radius: 20px!important;
}

.grade-select .footer {
  min-height: 30px;
  border-bottom-left-radius: 20px!important;
  border-bottom-right-radius: 20px!important;
}

.island a {
  color: black;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
</style>
